// extracted by mini-css-extract-plugin
export default {"root":"page-title_root__iXBO7","title":"page-title_title__yqxoW","content":"page-title_content__GTlPW"};